<div class="d-flex justify-content-end flex-wrap">
    <!-- DATE RANGE -->
    <div class="mr-3 mb-3">
        <button class="btn btn-default btn-inverted" (click)="picker.open()">
            {{ l("SelectDateRange") }}
        </button>

        <div
            style="
                visibility: hidden;
                pointer-events: none;
                height: 0px;
                width: 0px;
            "
        >
            <mat-form-field appearance="fill">
                <mat-date-range-input
                    [formGroup]="rangeFormGroup"
                    [rangePicker]="picker"
                >
                    <input
                        matStartDate
                        formControlName="start"
                        placeholder="Start date"
                    />
                    <input
                        matEndDate
                        formControlName="end"
                        placeholder="End date"
                    />
                </mat-date-range-input>
                <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker
                    #picker
                    (closed)="datapickerClose()"
                ></mat-date-range-picker>

                <mat-error
                    *ngIf="
                        rangeFormGroup.controls.start.hasError(
                            'matStartDateInvalid'
                        )
                    "
                    >Invalid start date</mat-error
                >
                <mat-error
                    *ngIf="
                        rangeFormGroup.controls.end.hasError(
                            'matEndDateInvalid'
                        )
                    "
                    >Invalid end date</mat-error
                >
            </mat-form-field>
        </div>
    </div>

    <!-- CREATOR -->
    <div class="mr-3 mb-3">
        <button
            class="btn btn-default btn-inverted"
            (click)="creatorSelector.open()"
        >
            {{ l("SelectCreator") }}
        </button>

        <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
            <mat-form-field>
                <mat-select
                    [formControl]="creatorFormCtrl"
                    [multiple]="true"
                    #creatorSelector
                >
                    <mat-option>
                        <ngx-mat-select-search
                            noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a creator..."
                            [formControl]="creatorFilterFormCtrl"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let creator of filteredCreator | async"
                        [value]="creator"
                        (click)="refresh()"
                    >
                        {{ creator.displayName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <!-- SIGN OFF -->
    <div class="mr-3 mb-3">
        <button
            class="btn btn-default btn-inverted"
            (click)="signOffSelector.open()"
        >
            {{ l("SelectSignOff") }}
        </button>

        <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
            <mat-form-field>
                <mat-select
                    [formControl]="signOffFormCtrl"
                    [multiple]="true"
                    #signOffSelector
                >
                    <mat-option>
                        <ngx-mat-select-search
                            noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a sign off..."
                            [formControl]="signOffFilterFormCtrl"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let signOff of filteredSignOff | async"
                        [value]="signOff"
                        (click)="refresh()"
                    >
                        {{ signOff.displayName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <!-- LOCATION -->
    <div class="mr-3 mb-3">
        <button
            class="btn btn-default btn-inverted"
            (click)="locationSelector.open()"
        >
            {{ l("SelectLocation") }}
        </button>

        <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
            <mat-form-field>
                <mat-select
                    [formControl]="locationFormCtrl"
                    [multiple]="true"
                    #locationSelector
                >
                    <mat-option>
                        <ngx-mat-select-search
                            noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a location..."
                            [formControl]="locationFilterFormCtrl"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let location of filteredLocation | async"
                        [value]="location"
                        (click)="refresh()"
                    >
                        {{ location.location.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <!-- STATUS -->
    <div class="btn-group dropdown mr-3 mb-3" dropdown container="body">
        <button class="btn btn-default btn-inverted" dropdownToggle>
            {{ l("AllocationStatus") }}
        </button>

        <ul class="dropdown-menu" style="max-width:180px;overflow-y:auto" *dropdownMenu>
            <li *ngFor="let enum of allocationStatuses">
                <button
                    (click)="setStatusFilter(enum.value)"
                    class="dropdown-item btn-primary"
                >
                    {{ l(enum.key) }}
                </button>
            </li>
        </ul>
    </div>

    <!-- CLEAR ALL FILTER -->
    <div class="mb-3">
        <button
            title="{{ l('ResetFilters') }}"
            class="btn btn-default"
            (click)="clearFilters()"
        >
            <i class="fa fa-redo"></i>
        </button>
    </div>
</div>
